/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import wsSend_request from "../../Api/ws/ws_request";
import { WebSocketContext } from "../../App";
import FormLayout from "../RecipientManagement/FormLayout";
import InputField from "../RecipientManagement/InputField";
const ProfileUpdate = () => {
  const {
    register,
    handleSubmit,
    // watch,
    formState: { errors },
    // setError,
    // clearErrors,
    reset,
    control
  } = useForm(
        {
    defaultValues: {
      machines: [], 
    },
  }
  );
      const { fields, append, remove,replace } = useFieldArray({
      control,
      name: "machines",
    });
    
  
  const navigate = useNavigate();
  const { selfInfo,singleRecipinet } = useSelector((state) => state.adminReducers);
  const [filtered, setFiltered] = useState([]);
  const { websocket } = useContext(WebSocketContext);
  
    useEffect(() => {
        const payload = {
          transmit: "single",
          url: "recipient_get",
          request: { recipient_id: selfInfo?.id },
        };
        wsSend_request(websocket, payload);
    }, []);
  useEffect(() => {
    reset({
      accountName: singleRecipinet?.recipient_account_name,
      recipientName: singleRecipinet?.username,
      email: singleRecipinet?.email,
      machineName: singleRecipinet?.recipient_machine_name,
    });
    replace(singleRecipinet?.machine_list_with_recipient)

  }, [singleRecipinet]);

  const onSubmit = (data) => {
    navigate();
  };
  return (
    <>
      <FormLayout title="Profile" isNoBack={false}>
        <form onSubmit={handleSubmit(onSubmit)} className="container">
          <div className="row">
            <div className="col-md-5">
              <InputField
                label="Recipient Login Id"
                name="accountName"
                register={register}
                required
                errors={errors}
                placeholder="Enter Recipient Login Id"
                disabled={true}
                isLock={true}
              />
            </div>
            <div className="col-md-5 ">
              <InputField
                label="Recipient Name"
                name="recipientName"
                register={register}
                required
                errors={errors}
                placeholder="Enter Recipient Name"
                disabled={true}
                isLock={true}
              />
            </div>
          </div>

          <div className="col-10">
            <InputField
              label="Recipient Email"
              name="email"
              register={register}
              required
              errors={errors}
              type="email"
              placeholder="Enter Recipient Email"
              disabled={true}
              isLock={true}
            />
          </div>

                   {fields?.map((item, index) => (
                  <div className="row" key={item?.id}>
                    <div className="col-md-5">
                      <InputField
                label="Recipient Machine Name"
                name={`machines.${index}.machineName`}
                placeholder="Enter Machine Name"
                register={register}
                errors={errors}
                required={true}
                isNewError={true}
                   disabled={true}
                   isLock={true}
          />
          
                    </div>
                    <div className="col-md-5">
                      <InputField
                        label="Machine ID"
                        placeholder="Machine Code"
                        name={`machines.${index}.machineID`}
                         register={register}
                        defaultValue={item.machineID} 
                        errors={errors}
                        disabled={true}
                      required={true}
                      isLock={true}
                      />
                    </div>
              </div>
                ))}
        </form>
      </FormLayout>
    </>
  );
};

export default ProfileUpdate;
